import { Box, Form } from '@jfs/ui-new'
import { useCallback, useEffect, useRef } from 'react'
import { Container } from '../../../comps/Container'
import { useLazyApiData, useStores } from '../../../data/store'
import { getErrorMessage } from '../../../util/utill'
import { ActionButtons } from './ActionButton'
import { FORM_FIELDS, OtpForm } from './OtpForm'
import { styles } from './styles'

export const UtrRefCustomerValidationScreen = () => {
  const { customerMobileNumber, sendOtp } = useStores((store) => ({
    customerMobileNumber: store.reGenerateRefundCode.getMobileNum(),
    sendOtp: store.customer.generateCustomerOtp,
  }))

  const [lazyGenerateOtpApi, generateOtpApiHandler] = useLazyApiData(sendOtp)
  const [lazyResendOtpApi, resendOtpApiHandler] = useLazyApiData(sendOtp)

  const sendOtpRetry = useRef(0)

  const onResendOtpButtonPress = useCallback(() => {
    sendOtpRetry.current += 1
    lazyResendOtpApi(customerMobileNumber)
  }, [customerMobileNumber, lazyResendOtpApi])

  useEffect(() => lazyGenerateOtpApi(customerMobileNumber), [customerMobileNumber, lazyGenerateOtpApi])
  const getFormData = () => {
    return [
      ...OtpForm({
        customerMobileNumber,
        onResendOtpButtonPress,
        isResendOtpLoading: resendOtpApiHandler.state === 'pending',
        sendOtpRetryCount: sendOtpRetry?.current,
      }),
    ]
  }
  return (
    <Container
      type="refund"
      title="Customer Validation"
      showFooter={true}
      isLoading={generateOtpApiHandler.state === 'pending'}
      errorMessage={getErrorMessage(generateOtpApiHandler)}
      onRetry={() => lazyGenerateOtpApi(customerMobileNumber)}>
      <Form
        formData={getFormData()}
        container={({ children }) => <Box {...styles.formContainer}>{children}</Box>}
        actionButtons={(props) => <ActionButtons {...props} customerMobileNumber={customerMobileNumber} />}
        initialValues={{
          [FORM_FIELDS.MOBILE]: '',
          [FORM_FIELDS.OTP]: '',
          [FORM_FIELDS.DEBIT_AMOUNT_INFO]: '',
        }}
      />
    </Container>
  )
}
